import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { env } from '../../environments/environment';
import { QuestionTag } from '../shared/interfaces';

@Injectable({
  providedIn: 'root',
})
export class QuestionTagService {
  constructor(protected http: HttpClient) {}

  async create(questionTag: QuestionTag) {
    return this.http.post<QuestionTag>(`${env.APIUrl}/question/questionTag`, questionTag).toPromise();
  }
}
